/* Drawer-only flow: no verification, cleanup, or checkout interception. */
(() => {
  if(window.OCQBCart)return;
  const request=async(url,body)=>{
    const response=await fetch((window.Shopify?.routes?.root||'/')+url,{method:body?'POST':'GET',headers:{Accept:'application/json',...(body?{'Content-Type':'application/json'}:{})},...(body?{body:JSON.stringify(body)}:{})});
    const data=await response.json();
    if(!response.ok||data.status)throw new Error(data.description||'Impossible de mettre à jour le panier.');
    return data;
  };
  let busy=false;
  const sectionIds=['cart-drawer','cart-icon-bubble'];
  function start(button){
    const drawer=document.querySelector('cart-drawer');
    if(!drawer||typeof drawer.open!=='function')throw new Error('Le panier latéral est indisponible. Veuillez actualiser la page.');
    drawer.setActiveElement?.(button);return drawer;
  }
  function render(sections){
    const drawer=document.querySelector('cart-drawer'),html=sections?.['cart-drawer'];
    const parsed=typeof html==='string'?new DOMParser().parseFromString(html,'text/html').querySelector('#CartDrawer'):null;
    if(!drawer||!parsed)throw new Error('Les articles ont été ajoutés. Actualisez le panier pour les afficher.');
    if(typeof drawer.replaceDrawer==='function')drawer.replaceDrawer(parsed);
    else {
      const current=drawer.querySelector('#CartDrawer');if(!current)throw new Error('Panier indisponible.');
      current.innerHTML=parsed.innerHTML;
      drawer.classList.toggle('is-empty',!!current.querySelector('cart-drawer-items.is-empty'));
    }
    const bubbleHTML=sections['cart-icon-bubble'];
    const bubble=typeof bubbleHTML==='string'?new DOMParser().parseFromString(bubbleHTML,'text/html').querySelector('.shopify-section'):null;
    const existing=document.getElementById('cart-icon-bubble');if(bubble&&existing)existing.innerHTML=bubble.innerHTML;
    drawer.setHeaderCartIconAccessibility?.();drawer.open();
  }
  async function refresh(){
    const url=new URL(window.location.href);url.searchParams.set('sections',sectionIds.join(','));
    const response=await fetch(url.pathname+url.search,{headers:{Accept:'application/json'}});
    if(!response.ok)throw new Error('Impossible d’afficher le panier. Réessayez.');
    const sections=await response.json();render(sections);return sections;
  }
  window.OCQBCart={request,start,render,refresh,sectionIds,get busy(){return busy;},async serial(task){if(busy)return;busy=true;try{return await task();}finally{busy=false;}}};
})();
